/* Adivasi eBazar — Forest Premium redesign behaviour.
   Community tabs, quick add-to-basket with toast, and the batch lookup on
   /pages/traceability. Progressive enhancement: without JS every link and
   form still works (forms post to /cart/add, tabs show the first community). */
(function () {
  'use strict';

  /* ── community tabs ─────────────────────────────────────────── */
  function initTabs(root) {
    var tabs = root.querySelectorAll('[data-aeb-tab]');
    var panels = root.querySelectorAll('[data-aeb-panel]');
    if (!tabs.length) return;
    function select(i, focus) {
      for (var t = 0; t < tabs.length; t++) {
        var on = t === i;
        tabs[t].setAttribute('aria-selected', on ? 'true' : 'false');
        tabs[t].tabIndex = on ? 0 : -1;
        if (on && focus) tabs[t].focus();
      }
      for (var p = 0; p < panels.length; p++) {
        var show = p === i;
        panels[p].hidden = !show;
        if (show) {
          panels[p].classList.remove('aeb-swap');
          void panels[p].offsetWidth; // restart the swap animation
          panels[p].classList.add('aeb-swap');
        }
      }
    }
    for (var i = 0; i < tabs.length; i++) {
      (function (idx) {
        tabs[idx].addEventListener('click', function () { select(idx, false); });
        tabs[idx].addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
            e.preventDefault();
            var next = (idx + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length;
            select(next, true);
          }
        });
      })(i);
    }
  }

  /* ── quick add to basket ────────────────────────────────────── */
  var toastTimer;
  function toast(title) {
    var old = document.querySelector('.aeb-toast');
    if (old) old.remove();
    var el = document.createElement('div');
    el.className = 'aeb-toast';
    el.setAttribute('role', 'status');
    var tick = document.createElement('span');
    tick.className = 'aeb-toast__tick';
    tick.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';
    var text = document.createElement('span');
    text.textContent = 'Added ' + title;
    var link = document.createElement('a');
    link.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart';
    link.textContent = 'View basket';
    el.appendChild(tick); el.appendChild(text); el.appendChild(link);
    document.body.appendChild(el);
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.remove(); }, 3600);
  }

  function updateBubble() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var icon = document.querySelector('cart-icon');
        if (icon && typeof icon.renderCartBubble === 'function') icon.renderCartBubble(cart.item_count, true);
      })
      .catch(function () {});
  }

  function initAddForms() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.classList || !form.classList.contains('aeb-add-form')) return;
      e.preventDefault();
      var btn = form.querySelector('button');
      var label = btn ? btn.querySelector('span') : null;
      if (btn) btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(function () {
          if (btn) { btn.classList.add('is-added'); btn.disabled = false; }
          if (label) label.textContent = 'Added';
          setTimeout(function () {
            if (btn) btn.classList.remove('is-added');
            if (label) label.textContent = 'Add';
          }, 1600);
          toast(form.getAttribute('data-product-title') || '');
          updateBubble();
        })
        .catch(function () {
          // fall back to a normal form post (goes to the cart page)
          form.classList.remove('aeb-add-form');
          form.submit();
        });
    });
  }

  /* ── traceability lookup ────────────────────────────────────── */
  function initTrace(root) {
    var input = root.querySelector('[data-aeb-trace-input]');
    var records = root.querySelectorAll('[data-aeb-record]');
    var empty = root.querySelector('[data-aeb-trace-empty]');
    if (!input || !records.length) return;
    function filter(q, scroll) {
      q = (q || '').trim().toLowerCase();
      var shown = 0, first = null;
      for (var i = 0; i < records.length; i++) {
        var hay = records[i].getAttribute('data-aeb-record');
        var match = !q || hay.indexOf(q) !== -1;
        records[i].hidden = !match;
        records[i].classList.toggle('is-match', !!q && match);
        if (match) { shown++; if (!first) first = records[i]; }
      }
      if (empty) empty.hidden = shown !== 0;
      if (scroll && first && q) first.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    input.addEventListener('input', function () { filter(input.value, false); });
    if (input.form) input.form.addEventListener('submit', function (e) { e.preventDefault(); filter(input.value, true); });
    var params = new URLSearchParams(window.location.search);
    var batch = params.get('batch');
    if (batch) { input.value = batch; filter(batch, true); }
  }

  function init() {
    var tabRoots = document.querySelectorAll('[data-aeb-tabs]');
    for (var i = 0; i < tabRoots.length; i++) initTabs(tabRoots[i]);
    var traceRoots = document.querySelectorAll('[data-aeb-trace]');
    for (var j = 0; j < traceRoots.length; j++) initTrace(traceRoots[j]);
    initAddForms();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();